import { actionCreator } from 'utils';
import * as PlanningTypes from '../types/planningTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    simulate: null,
    plan: null,
    calculation: false,
    extraParams: {
        recalculation: true,
        locked: false,
    },
    redirection: false,
    save: {
        loading: false,
        success: false,
        error: false,
    },
    reservation: {
        loading: false,
        error: false,
        edit: null,
    },
    filters: {
        form_id: '',
        form_version_id: '',
        job_id: '',
        palette_id: '',
        roll_out_id: '',
        order_id: '',
        customer: '',
        design_id: '',
        only_reservations: false,
    },
    forms: [],
    replan: null,
};

export default function (state = initState, action) {
    switch (action.type) {
    case PlanningTypes.LOAD_PLANNING:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(PlanningTypes.LOAD_PLANNING, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(PlanningTypes.LOAD_PLANNING, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case PlanningTypes.SET_PLANNING_FILTER:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case PlanningTypes.RESET_PLANNING_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                ...initState.filters,
            },
        });

    case PlanningTypes.PREPARE_FORM_VERSION:
        return Object.assign({}, state, {
            plan: action.data === null ? null : {
                ...state.plan,
                ...action.data,
            },
        });

    case PlanningTypes.SIMULATE_FORM_VERSION_PLANNING:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(PlanningTypes.SIMULATE_FORM_VERSION_PLANNING, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: {
                ...state.listing,
                events: [
                    ...state.listing.events.filter(event => event.type !== 'new'),
                    ...action.data,
                ],
            },
        });

    case actionCreator(PlanningTypes.SIMULATE_FORM_VERSION_PLANNING, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case PlanningTypes.REMOVE_NEW_EVENTS:
        return Object.assign({}, state, {
            loading: false,
            listing: {
                ...state.listing,
                events: state.listing ? state.listing.events.filter(event => event.type !== 'new') : [],
            },
        });

    case PlanningTypes.PLAN_FORM_VERSION:
        return Object.assign({}, state, {
            save: {
                ...state.save,
                loading: true,
                error: false,
            },
        });

    case actionCreator(PlanningTypes.PLAN_FORM_VERSION, 'res'):
        return Object.assign({}, state, {
            save: {
                ...state.save,
                success: true,
                loading: false,
            },
        });

    case actionCreator(PlanningTypes.PLAN_FORM_VERSION, 'err'):
        return Object.assign({}, state, {
            save: {
                ...state.save,
                error: true,
                loading: false,
            },
        });

    case PlanningTypes.EDIT_FORM_VERSION:
        return Object.assign({}, state, {
            save: {
                ...state.save,
                loading: true,
                error: false,
            },
        });

    case PlanningTypes.PLAN_BLUK_FORM_VERSIONS:
        return Object.assign({}, state, {
            save: {
                ...state.save,
                loading: true,
                error: false,
            },
        });

    case actionCreator(PlanningTypes.EDIT_FORM_VERSION, 'res'):
        return Object.assign({}, state, {
            save: {
                ...state.save,
                success: true,
                loading: false,
            },
        });

    case actionCreator(PlanningTypes.EDIT_FORM_VERSION, 'err'):
        return Object.assign({}, state, {
            save: {
                ...state.save,
                error: true,
                loading: false,
            },
        });


    case PlanningTypes.ADD_RESERVATION:
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                loading: true,
                error: false,
            },
        });

    case actionCreator(PlanningTypes.ADD_RESERVATION, 'res'):
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                loading: false,
            },
        });

    case actionCreator(PlanningTypes.ADD_RESERVATION, 'err'):
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                error: true,
                loading: false,
            },
        });

    case PlanningTypes.DELETE_RESERVATION:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(PlanningTypes.DELETE_RESERVATION, 'res'):
        return Object.assign({}, state, {
            loading: false,
        });

    case actionCreator(PlanningTypes.DELETE_RESERVATION, 'err'):
        return Object.assign({}, state, {
            loading: false,
        });

    case PlanningTypes.PREPARE_BULK_FORMS:
        return Object.assign({}, state, {
            forms: action.forms,
        });

    case PlanningTypes.DISPLAY_REDIRECTION_BUTTON:
        return Object.assign({}, state, {
            redirection: action.data,
        });

    case PlanningTypes.SET_CALCULATION_STATUS:
        return Object.assign({}, state, {
            calculation: action.status,
        });

    case PlanningTypes.SET_EXTRA_PARAMS:
        return Object.assign({}, state, {
            extraParams: {
                ...state.extraParams,
                ...action.payload,
            },
        });

    case PlanningTypes.TOGGLE_REPLAN_GROUPED_FVS:
        return Object.assign({}, state, {
            replan: action.payload,
        });

    case PlanningTypes.TOGGLE_EDIT_RESERVATION:
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                edit: action.payload,
            },
        });

    case PlanningTypes.EDIT_RESERVATION:
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                loading: true,
                error: false,
            },
        });

    case actionCreator(PlanningTypes.EDIT_RESERVATION, 'res'):
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                loading: false,
                edit: null,
            },
        });

    case actionCreator(PlanningTypes.EDIT_RESERVATION, 'err'):
        return Object.assign({}, state, {
            reservation: {
                ...state.reservation,
                error: true,
                loading: false,
            },
        });

    default:
        return state;
    }
}
